// @flow
import styled, { css } from 'styled-components';
import { jetBlack, cleanWhite } from '../../colors';
import { calculateRelativePosition, calculateArrowPosition } from '../utils';
export var ArrowBaseCss = css(["position:absolute;content:'';width:0;height:0;font-size:1.4rem;"]);
export var positionBottom = function positionBottom(tooltipHeight
/* :number */
) {
  return css(["bottom:", "px;left:50%;transform:translateX(-50%);"], -1 * tooltipHeight - 1);
};
export var positionTop = function positionTop(tooltipHeight
/* :number */
) {
  return css(["top:", "px;left:50%;transform:translateX(-50%);"], -1 * tooltipHeight - 1);
};
export var positionRight = function positionRight(tooltipWidth
/* :number */
) {
  return css(["top:50%;transform:translateY(-50%);right:", "px;"], -1 * tooltipWidth + 2);
};
export var positionLeft = function positionLeft(tooltipWidth
/* :number */
) {
  return css(["top:50%;transform:translateY(-50%);left:", "px;"], -1 * tooltipWidth + 1);
};
/*::
import type {
  StyledComponent,
  FlattenSimpleInterpolation
} from 'styled-components';
import type { TooltipPosition } from '../index';

export type TransparentOffsetProps = {
  visible?: boolean;
  initiallyVisible?: boolean;
  tooltipPosition?: TooltipPosition;
  tooltipHeight?: number;
  tooltipWidth?: number;
  // rest props
  [key: string]: any;
}

export type MainProps = {
  tooltipPosition?: TooltipPosition;
  // rest props
  [key: string]: any;
}

export type TooltipThemeType = {
  TransparentOffset: StyledComponent<'div', any, TransparentOffsetProps>,
  Main: StyledComponent<'div', any, MainProps>,
  ArrowTopCss: FlattenSimpleInterpolation,
  ArrowBottomCss: FlattenSimpleInterpolation,
  ArrowLeftCss: FlattenSimpleInterpolation,
  ArrowRightCss: FlattenSimpleInterpolation,
};
*/

var theme
/* : TooltipThemeType */
= {
  ArrowTopCss: css(["", " top:1px;left:50%;transform:translate(-50%,-100%);border-left:1rem solid transparent;border-right:1rem solid transparent;border-bottom:1rem solid ", ";"], ArrowBaseCss, jetBlack(0.8)),
  ArrowBottomCss: css(["", " bottom:1px;left:50%;transform:translate(-50%,100%);border-left:1rem solid transparent;border-right:1rem solid transparent;border-top:1rem solid ", ";"], ArrowBaseCss, jetBlack(0.8)),
  ArrowLeftCss: css(["", " top:50%;left:1px;transform:translate(-100%,-50%);border-right:1rem solid ", ";border-bottom:1rem solid transparent;border-top:1rem solid transparent;"], ArrowBaseCss, jetBlack(0.8)),
  ArrowRightCss: css(["", " top:50%;right:1px;transform:translate(100%,-50%);border-left:1rem solid ", ";border-bottom:1rem solid transparent;border-top:1rem solid transparent;"], ArrowBaseCss, jetBlack(0.8)),
  TransparentOffset: styled.div.withConfig({
    displayName: "theme__TransparentOffset",
    componentId: "dj5c0-0"
  })(["position:absolute;z-index:3;", " opacity:", ";visibility:", ";transition:opacity 1s ease-in-out;"], function (pr) {
    return calculateRelativePosition(pr);
  }, function (pr) {
    return pr.initiallyVisible ? 1 : 0;
  }, function (pr) {
    return pr.visible ? 'visible' : 'hidden';
  }),
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "dj5c0-1"
  })(["position:relative;padding:2.4rem 1.6rem;background:", ";color:", ";border-radius:4px;overflow-wrap:break-word;&:before{", "}"], jetBlack(0.8), cleanWhite(), function (pr) {
    return calculateArrowPosition(pr);
  })
};
export default theme;